import echarts from "echarts";
import { reactive, toRefs, ref } from "vue";
import { getJson } from "@/api/public";
export function useChinaMap(data) {
    const state = reactive({
        echartData: [],
        myChart:''
    })
    const mapJson=ref()
    // 获取初始地图省市区及定义点击方法
    const mapChart = async (e) => {
        mapJson.value =  await getJson(e).then(res => res.data)
        registerAndsetOption(
            state.myChart,
            Number(e.id),
            String(e.name),
            mapJson.value,
            true
        )
    };
    const dataHandle=(data)=>{
        var mapData = [];
        data.forEach((element) => {
            if(!element.name)return
            var name = element.name;
            mapData.push({
                name: name,
                value: element.count,
            });
        });
        return mapData
    }
    // 初始化数据
    const initMap = (ref) => {
        const chart = ref
        state.myChart = echarts.init(chart);
        mapChart({id:"100000",name:'china'});
    }
    const setMap=(e,data)=>{
        console.log(e,data)
        state.echartData=dataHandle(data)
        mapChart(e)
    }
    /**
     *
     * @param {*} myChart
     * @param {*} id        省市县Id
     * @param {*} name      省市县名称
     * @param {*} mapJson   地图Json数据
     * @param {*} flag      是否往mapStack里添加parentId，parentName
     */
    function registerAndsetOption(myChart, id, name, mapJson, flag) {
        echarts.registerMap(name, mapJson);
        myChart.setOption({
            tooltip: {
                formatter: "{b}<br/>经销商数量：{c}",
            },
            legend: {
                orient: "horizontal",
                bottom: "bottom",
            },
            visualMap: {
                min: 0,
                max: 1500,
                right: 0,
                orient: "horizontal",
                top: "bottom",
                text: ["高", "低"],
                calculable: true,
                color: ["#05486A", "#fff"],
            },
            selectedMode: "single",
            series: [
                {
                    name: "",
                    type: "map",
                    map: name,
                    zoom: 1.1,
                    itemStyle: {
                        normal: {
                            borderColor: "rgba(0, 0, 0, 0.2)",
                        },
                        emphasis: {
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            shadowBlur: 20,
                            borderWidth: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                    showLegendSymbol: true,
                    label: {
                        normal: {
                            show: true,
                        },
                        emphasis: {
                            show: true,
                        },
                    },
                    data: state.echartData,
                },
            ],
        });
    }
    return {
        initMap,
        ...toRefs(state),
        setMap
    }
}